import React from 'react';
import { Emoji } from './Emoji';
export function Garantia() {
  return <section className="w-full bg-forest-900 py-12 sm:py-16" data-id="element-109" data-mp="1x5dkn6h0phvy">
      <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-[820px]" data-id="element-110" data-mp="1x5vmqjqd2qbs">
        <div className="rounded-3xl border-2 border-lime-400/40 bg-pistacho px-5 py-8 text-center sm:px-10 sm:py-10" data-id="element-111" data-mp="223ngzkehaoj5">
          <Emoji symbol="🛡️" className="mx-auto block text-5xl" data-id="element-112" data-mp="274unlg4vxho8" />
          <h2 className="mt-5 font-display text-[clamp(1.3rem,5.5vw,1.875rem)] font-extrabold uppercase tracking-tight text-forest-950" data-id="element-113" data-mp="2b43hckzxdfjs">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[14px] leading-relaxed text-forest-800 sm:text-[15px]" data-id="element-114" data-mp="2kuod80o7s5z0">
            Descargás los tomos. Los usás en tu cocina. Si en 7 días no es
            exactamente lo que esperabas, escribís a{' '}
            <a href="mailto:closethegap14@gmail.com" className="break-all font-semibold text-lime-700 underline underline-offset-2" data-id="element-115" data-mp="2uuyo3ems11b0">
              closethegap14@gmail.com
            </a>{' '}
            y te devolvemos el{' '}
            <strong className="font-bold text-forest-950" data-id="element-116" data-mp="3allbdeujxpal">
              100% de tu dinero
            </strong>
            . Sin formularios. Sin drama. Sin explicaciones.
          </p>
          <p className="mt-4 text-[13px] font-bold text-lime-700 sm:text-sm" data-id="element-117" data-mp="30p8i2i2x5dgd">
            Tasa de devoluciones: menos del 1%.
          </p>
          <p className="mx-auto mt-4 max-w-lg text-[13px] text-forest-600/85 sm:text-sm" data-id="element-118" data-mp="261gkbe8fytf">
            Podemos ofrecer esta garantía porque sabemos lo que el sistema hace
            cuando alguien realmente lo usa.
          </p>
        </div>
      </div>
    </section>;
}